/* @jsx h */
import { useCustomer, useMenu } from "@app/vue/providers/index";
import { CustomerCheckout, PaymentDetails } from "@lemmonhq/types";
import { Loading, useLocalization } from "@lemmonhq/uikit";
import { computed, defineComponent, onMounted, ref, h } from "vue";
import { useRoute } from "vue-router";
import { ShopCheckoutResultPage } from "../ShopCheckoutResult/index";
import { ErrorState } from "./components";
import { GroupedCheckoutStatus } from "./GroupedCheckoutStatus";
import { SingleCheckoutStatus } from "./SingleCheckoutStatus";

export const ShopCheckoutStatusPage = defineComponent({
  name: "ShopCheckoutStatusPage",
  setup() {
    const { groupOrder, refetchGroupOrder } = useMenu();
    const { customer } = useCustomer();
    const route = useRoute();
    const { t } = useLocalization();
    const randomUserCheckout = computed(() => {
      if (!groupOrder.value?.checkouts) {
        return null;
      }

      const checkoutId = route.params.checkoutId as string;

      // First try to find by checkoutId from URL param
      if (checkoutId) {
        const checkout = groupOrder.value.checkouts.find(
          (c) => c.id === checkoutId,
        );
        if (checkout) return { checkout: checkout as CustomerCheckout };
      }

      // Fall back to finding by current customer id
      if (!customer.value?.id) return null;
      const checkout = groupOrder.value.checkouts.find(
        (c) => c.customer_id === customer.value?.id,
      );

      if (!checkout) return null;

      return {
        checkout: checkout as CustomerCheckout,
      };
    });
    const isLoading = ref(true);

    // Check if the checkout from the URL is completed
    const allUserCheckoutsCompleted = computed(() => {
      if (!randomUserCheckout.value) return false;
      return randomUserCheckout.value.checkout.status === "completed";
    });

    onMounted(async () => {
      await refetchGroupOrder();
      isLoading.value = false;
    });

    return () => {
      if (isLoading.value) {
        return (
          <div class="flex-1 flex justify-center items-center">
            <Loading />
          </div>
        );
      }
      // If all checkouts are completed with order IDs, show result page
      if (allUserCheckoutsCompleted.value) {
        return <ShopCheckoutResultPage />;
      }

      if (!randomUserCheckout.value) {
        return (
          <ErrorState
            error={t("customer.checkout_status.not_found")}
            onRetry={() => {}}
          />
        );
      }

      // todo improve typchecking here
      return randomUserCheckout.value.checkout.order_type === "single" ? (
        <SingleCheckoutStatus
          checkout={randomUserCheckout.value.checkout}
          //          payment={data.value.payment as PaymentDetails}
        />
      ) : (
        <GroupedCheckoutStatus
          checkout={randomUserCheckout.value.checkout as CustomerCheckout}
        />
      );
    };
  },
});
